import './Questions.css';
import '../Dashboard.css';
import Search from './Search/Search.js';
import Upload from './Upload/Upload.js';
import { useMemo, useState } from 'react';

const VIEWS = [
    {
        id: 'search-questions',
        title: 'Search',
        component: Search,
    }
];
const DEFAULT_VIEW = VIEWS[0];

function Questions({ toggleNav }) {
    const [view, setView] = useState(DEFAULT_VIEW);

    const renderView = useMemo(() => {
        const View = view.component;
        return <View key={view.id} toggleNav={toggleNav} />
    }, [view, toggleNav]);


    return (
        <div className="Questions">
            {renderView}
        </div>
    );

}

export default Questions;
